import { Component } from '@angular/core';

@Component({
  selector: 'ngx-public-layout',
  styleUrls: ['./public.layout.scss'],
  template: `
    <nb-layout class="no-column">
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-layout-column class="public">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class PublicLayoutComponent { }
